module.exports = __webpack_public_path__ + "static/sponsorship_img-04-a@2x-36e36447eca49beba6c24f141fa99701.jpg";